import { Component, ChangeDetectorRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingController } from '@ionic/angular';

// import { Sale } from '../../shared/models/sale.model';
// import { SALE_CHECKOUT_TYPE, SaleService } from '../../shared/services/sale.service';
import { SquareLocation, SquarePOSService } from '../../../services/square-pos.service';
import { UserService } from '../../../services/user.service';
import { Router } from '@angular/router';

// import { SafariViewController } from '@awesome-cordova-plugins/safari-view-controller';
@Component({
  selector: 'app-sale-square-oauth',
  templateUrl: './sale-square-oauth.page.html',
  styleUrls: ['./sale-square-oauth.page.scss'],
})
export class SaleSquareOauthPage implements OnInit {

  public accessToken: string;

  public merchantID: string;

  public completed: boolean;

  public errorOccured: boolean;

  constructor (
              //private navParams: NavParams,
              //private navCtrl: NavController,
              // private saleService: SaleService,
              private changeDetectorRef: ChangeDetectorRef,
              private userService: UserService,
              private squarePOSService: SquarePOSService,
              // private safariViewController: SafariViewController,
              //private viewController: ViewController
              private router: Router
              ) {
  }


  public ngOnInit () {
    // if (this.safariViewController.isAvailable()) {
      // this.safariViewController.hide()  
      //   .then(() => {
      //     'safariViewController hidden');
      //   })
      //   .catch((err) => {
      //   });
    // } else {
    // }
    
    this.saveCredentials();
  }

  public saveCredentials () {
    // this.completed = false;
    // this.errorOccured = false;
    
    // // Call our API to save/udpate the users credentials
    // this.squarePOSService.saveStylistOAuthCredentials(this.accessToken, this.merchantID)
    //   .subscribe((credentials) => {

        // set completed, and show our location picker
        this.completed = true;
        this.changeDetectorRef.markForCheck();
      // },
      // (err) => {
      //   this.errorOccured = false;
      // });
  }

  public onLocationPick ($event) {
    this.squarePOSService.setSquareBusinessLocation($event);
    //this.navCtrl.setRoot("SettingListPage");
    this.router.navigateByUrl('/settings');
  }

}
